export const CUP_SCOPES = [
  {
    scope: "BDL",
    abbreviation: "Pokal",
    placeholderName: "Pokal (noch nicht angelegt)",
  },
  {
    scope: "SBL",
    abbreviation: "Pokal SBL",
    placeholderName: "Pokal Südbadenliga (noch nicht angelegt)",
  },
];
